// Constants for the FarmDash application

export const OBJECTIVES = {};

export const ROI_SCENARIOS = {
  'Extended': { bearish: 3, base: 5, bullish: 10 },
  'Variational': { bearish: 20, base: 45, bullish: 90 },
  'Predict Fun': { bearish: 0.2, base: 0.5, bullish: 1 }
};

export const TGE_ESTIMATES = {
  'Extended': 'H1 2026',
  'Variational': 'Q3 2026',
  'Polymarket': '2026',
  'Predict Fun': 'TBD'
};

export const DEFAULT_ALERTS = [
  { id: 1, text: '🗓️ Martes: Extended puntos', type: 'recurring', active: true },
  { id: 2, text: '🗓️ Jueves: Predict Fun puntos', type: 'recurring', active: true },
  { id: 3, text: '🗓️ Viernes: Variational puntos', type: 'recurring', active: true }
];

export const DEFAULT_CALENDAR_EVENTS = [
  { id: 1, title: 'Extended TGE', date: '2026-06-30', type: 'tge', project: 'Extended' },
  { id: 2, title: 'Variational TGE', date: '2026-09-30', type: 'tge', project: 'Variational' },
  { id: 3, title: 'Polymarket TGE', date: '2026-12-31', type: 'tge', project: 'Polymarket' }
];

export const DEFAULT_PROJECT_SETTINGS = {};

export const PROJECT_CONFIGS = [];

export const TIME_RANGES = {
  week: 'Semana',
  month: 'Mes',
  quarter: 'Trimestre',
  year: 'Año'
};

export const TABS = [
  { id: 'overview', label: 'General' },
  { id: 'objectives', label: 'Targets' },
  { id: 'roi', label: 'ROI' },
  { id: 'projects', label: 'Airdrops' },
  { id: 'airdrops-received', label: 'Recibidos' },
  { id: 'calendar', label: 'Calendario' },
  { id: 'history', label: 'Histórico' },
  { id: 'add', label: 'Añadir' }
];

export const AIRDROP_TARGET = 1000000; // $1M target for 2026
